import { render } from "./batchDisable.vue?vue&type=template&id=5f7c4b31"
import script from "./batchDisable.vue?vue&type=script&lang=js"
export * from "./batchDisable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__